module.exports = __webpack_public_path__ + "static/media/Stellar Ora King Headboard - 180 cm_Natural.1e2eef85.png";